import React from 'react'
import './SchTable.css'

const SchTableTwo = ({ dataSchTwo }) => {
  return (
    <div className="app__table-schedule">
    <table className="app__background-bk table-sch ">
        <thead className="app__sch__thead">
            <tr className="app__sch_tr" >
                <th className="app__sch_th">Field/Time</th>
                <th className="app__sch_th">L1a</th>
                <th className="app__sch_th">L1b</th>
                <th className="app__sch_th">L2a</th>
                <th className="app__sch_th">L2b</th>   
            </tr>
        </thead>
        <tbody className="sch__tbody">
            {dataSchTwo.map((row, index) => (
                <tr className="app__sch_tr" key={index}>
                    <td className="sDataTwo">{row.time}</td>
                    <td className="sDataTwo">{row.fieldL1a}</td>
                    <td className="sDataTwo">{row.fieldL1b}</td>
                    <td className="sDataTwo">{row.fieldL2a}</td>
                    <td className="sDataTwo">{row.fieldL2b}</td>
                </tr>
            ))}
        </tbody>
    </table>
</div>
);
}

export default SchTableTwo